import { CursorButton } from "../cursor"

export const CustomControls = () => {
	return (
		<div className="absolute bottom-4 right-4 z-10 flex flex-col items-end gap-2">
			<CursorButton />
		</div>
	)
}
